import { Avatar, Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { TreatmentAlert } from '../TreatmentAlert';
import { ArrowBackBlue } from 'Images';

export const TreatmentTitle = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Treatment);
  const isDesktop = useIsDesktop();

  return (
    <Stack gap={isDesktop ? '24px' : '16px'}>
      <Typography variant={'h3'} color={'text.secondary'} component='h1'>
        {dictionary.metaTitle}
      </Typography>
      <TreatmentAlert isBackgroundColorActive={false}>
        {
          <Stack gap={isDesktop ? '8px' : '4px'}>
            <Typography
              variant='body3'
              color={'text.secondary'}
              sx={{ marginRight: '5px' }}
            >
              {dictionary.info}
            </Typography>
            <Link
              width={'fit-content'}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              underline='hover'
              href={dictionary.infoLinkUrl}
              target='_blank'
              rel={'noopener'}
            >
              <Typography variant='body2'>
                {dictionary.infoLinkTitle}
              </Typography>
              <Avatar
                alt={''}
                src={ArrowBackBlue}
                sx={{ width: '16px', height: '16px', margin: 0 }}
              />
            </Link>
          </Stack>
        }
      </TreatmentAlert>
    </Stack>
  );
};
